class ProductCustomization {
    constructor(width, length, cuttof, overlap, productData, price, properties, isInit) {

        this.width = width;
        this.length = length;
        this.cuttof = cuttof;
        this.overlap = overlap;
        this.price = price;
        this.properties = properties;
        this.isInit = true;

        this.productData = [{
                "product_type": "Chapas 1 Lorem Ipsum",
                "product_price": "100",
                "product_width": "0.8"

            },
            {
                "product_type": "Chapas 2 Lorem Ipsum",
                "product_price": "200",
                "product_width": "0.9"

            },
            {
                "product_type": "Chapas 3 Lorem Ipsum",
                "product_price": "300",
                "product_width": "1.0"

            },
            {
                "product_type": "Chapas 4 Lorem Ipsum",
                "product_price": "400",
                "product_width": "1.1"

            }




        ]

        document.querySelectorAll("[data-product].variant-picker__option:not(.hidden)").forEach(option => {

            option.querySelector('input').checked = true;
        })
        document.querySelectorAll(".devCustomVariant [data-option-selector] input").forEach((input, index) => {
            input.value = chapasProducts[index].title;
            document.querySelectorAll(".devCustomVariant [data-option-selector] label")[index].querySelector("img").src = chapasProducts[index].image;

        });
        if (document.querySelector(`.devCustomVariant [value="${document.querySelector('.product-info__title').innerText}"]`)) {
            document.querySelector(`.devCustomVariant [value="${document.querySelector('.product-info__title').innerText}"]`).checked = true
        }


        let value = document.querySelector('.variant-picker__option-values [name="option"]:checked').value;
        this.productData.forEach(pr => {
            if (pr.product_type == value) {

                document.querySelector(".final-price").innerText = "$" + pr.product_price;
            }
        })
        this.setupListener();
        this.handleATC();
        this.updateVariants();

    }
    updatePrice = () => {
        document.querySelector(".final-price").innerText = "$" + this.price.toFixed("2")
    }
    updateVariants = () => {

      
        let selectedFirstProduct = document.querySelector("[data-product].variant-picker__option:not(.hidden)").dataset.product;
        let selectedFirstOptionValue = document.querySelector("[data-product].variant-picker__option:not(.hidden) [name='option1']:checked").value;

        let option1Available = Shopify[`optionsMap${selectedFirstProduct}`]['root'];
        document.querySelectorAll(`[data-product="${selectedFirstProduct}"] input[name='option1'],[data-product="${selectedFirstProduct}"] input[data-name='option1']`).forEach((input) => {
            if(!option1Available){
              input.labels[0].classList.add("is-disabled");
               // input.labels[0].style.display = "none";
               //  input.labels[0].classList.add("hidden");
            }
            else
              if (!option1Available.includes(input.value)) {

                input.labels[0].classList.add("is-disabled");
                  // input.labels[0].style.display = "none";
                  // input.labels[0].classList.add("hidden");
  
                  // input.disabled = true;
              } else {
                input.labels[0].classList.remove("is-disabled");
                  // input.labels[0].style.display = "grid";
                  // input.labels[0].classList.remove("hidden");
  
                  // input.disabled = false;
              }
          })

      
        let option2Available = Shopify[`optionsMap${selectedFirstProduct}`][selectedFirstOptionValue];
        

      
        document.querySelectorAll(`[data-product="${selectedFirstProduct}"] input[name='option2'],[data-product="${selectedFirstProduct}"] input[data-name='option2']`).forEach((input) => {
            if(!option2Available){
               // input.labels[0].style.display = "none";
               //    input.labels[0].classList.add("hidden");
              input.labels[0].classList.add("is-disabled");
            }
            else{

              if (!option2Available.includes(input.value)) {

               
                console.log(`DISABLED ____  ${input.value}`)
                  input.labels[0].classList.add("is-disabled");
                  // input.labels[0].style.display = "none";
                  // input.labels[0].classList.add("hidden");
  
                  // input.disabled = true;
              } else {

                console.log(`ENABLED ____  ${input.value}`)
                // debugger;
                  // input.labels[0].style.display = "grid";
                  // input.labels[0].classList.remove("hidden");
                input.labels[0].classList.remove("is-disabled");
  
                  // input.disabled = false;
              }
              
            }
              
        })
        
        
        let option2 =  document.querySelector("[data-product].variant-picker__option:not(.hidden) [data-name='option2']:checked").value;
        if (event) {
            if (document.querySelector("[data-product].variant-picker__option:not(.hidden) [name='option2']:checked") && !event.target.closest('[data-option="color"]')) {
                option2 = document.querySelector("[data-product].variant-picker__option:not(.hidden) [name='option2']:checked").value;

            } else {
                option2 = document.querySelector("[data-product].variant-picker__option:not(.hidden) [data-name='option2']:checked").value;

            }

        }

      


        if (document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option2']+label:not(.is-disabled)`) && !event) {
            let value = document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option2']+label:not(.is-disabled)`).dataset.optionValue;

            if(document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`)){
              document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`).checked = true;
            }
            
            document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option2']+label:not(.is-disabled)`).closest('fieldset').querySelector('variant-option-value').innerHTML = value;
        }


      if(document.querySelector("[data-product].variant-picker__option:not(.hidden) [data-name='option2']:checked+label").classList.contains('is-disabled')){
            let value = document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option2']+label:not(.hidden):not(.is-disabled)`)?.dataset.optionValue;
            if(document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`)){
              document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`).checked = true;
            }
            if(document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option2']+label:not(.hidden):not(.is-disabled)`)){
              
            
              document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option2']+label:not(.hidden):not(.is-disabled)`).closest('fieldset').querySelector('variant-option-value').innerHTML = value;
            }
            option2 =  document.querySelector("[data-product].variant-picker__option:not(.hidden):not(.is-disabled) [data-name='option2']:checked").value;
        }

        let selectedOption2Available = selectedFirstOptionValue + " / " + option2
        let option3Available = Shopify[`optionsMap${selectedFirstProduct}`][selectedOption2Available];


      
        let isHidden = false;
        if (option3Available) {


            document.querySelectorAll(`[data-product="${selectedFirstProduct}"] input[name='option3'], [data-product="${selectedFirstProduct}"] input[data-name='option3']`).forEach((input) => {
                if (!option3Available.includes(input.value)) {

                  input.labels[0].classList.add("is-disabled");

                    // input.labels[0].style.display = "none";
                    // input.labels[0].classList.add("hidden");

                    // input.disabled = true;
                } else {
                  input.labels[0].classList.remove("is-disabled");
                    // input.labels[0].style.display = "grid";
                    // input.labels[0].classList.remove("hidden");

                    // input.disabled = false;
                }

            })
        }
      else{
        document.querySelectorAll(`[data-product="${selectedFirstProduct}"] input[name='option3'], [data-product="${selectedFirstProduct}"] input[data-name='option3']`).forEach((input) => {
               

                  input.labels[0].classList.add("is-disabled");


            })
      }
        if (document.querySelector(`[data-product="${selectedFirstProduct}"] input[name='option3']+label:not(.is-disabled)`)) {
          
            let value = document.querySelector(`[data-product="${selectedFirstProduct}"] input[name='option3']+label:not(.is-disabled)`).dataset.optionValue;
            if(document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`)){
              document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`).checked = true;
            }
            document.querySelector(`[data-product="${selectedFirstProduct}"] input[name='option3']+label:not(.is-disabled)`).closest('fieldset').querySelector('variant-option-value').innerHTML = value;
        } else {
          if(document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option3']+label:not(.is-disabled)`)){
            
          
         
            let value = document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option3']+label:not(.is-disabled)`).dataset.optionValue;
            if(document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`)){
              document.querySelector(`[data-product="${selectedFirstProduct}"] input[value='${value}']`).checked = true;
            }
            
            document.querySelector(`[data-product="${selectedFirstProduct}"] input[data-name='option3']+label:not(.is-disabled)`).closest('fieldset').querySelector('variant-option-value').innerHTML = value;
          }
        }


      
       if (document.querySelector(`[data-product="${selectedFirstProduct}"] input[name='option1']:checked+label.is-disabled`)){
        
        document.querySelector(`[data-product="${selectedFirstProduct}"] input[name='option1']+label:not(.is-disabled)`).click();
      }

let selectedOptionsoFProduct = {};

// Gather selected options of the product
document.querySelectorAll(`[data-product='${selectedFirstProduct}'][data-option] input:checked`).forEach((input, index) => {
  selectedOptionsoFProduct[`option${index + 1}`] = input.value;
});

let variantsOfProduct = Shopify[`optionVariants${selectedFirstProduct}`];
let selectedVariant = null;  // Initialize selectedVariant

// Loop through all variants of the product to find the matching one
variantsOfProduct.forEach(varOfProduct => {
  // Check if all selected options match the variant's options
  if (
    varOfProduct["option1"] == selectedOptionsoFProduct['option1'] &&
    varOfProduct["option2"] == selectedOptionsoFProduct['option2'] &&
    varOfProduct["option3"] == selectedOptionsoFProduct['option3']
  ) {
    chapasVariant = varOfProduct;
    // selectedVariant = varOfProduct;  // Store the matched variant
    console.log("Matched Variant:", selectedVariant);  // Log the matched variant
    // debugger;  // Allow inspection in the browser's developer tools
  }
});



    

    }
    handleATC = () => {
        if (document.querySelector(".devProductSection .buy-buttons [type='submit']")) {


            document.querySelector(".devProductSection .buy-buttons [type='submit']").addEventListener("click", function(e) {

                e.preventDefault();



                Swal.fire({
                    position: 'center',
                    iconHtml: "<img src='https://cdn.shopify.com/s/files/1/0709/1332/7406/files/loader.gif?v=1681985680' >",
                    title: 'Por favor, espera',
                    showConfirmButton: false,
                    customClass: {
                        icon: 'no-border'
                    },
                    timer: 2000
                })
                let variants = [];
                let variant = {};
                let properties = {};

             

                document.querySelectorAll('fieldset:not(.hidden)[ name=option]:checked, fieldset:not(.hidden) [name=option1]:checked, fieldset:not(.hidden) [name=option2]:checked,fieldset:not(.hidden) [data-name="option1"]:checked,fieldset:not(.hidden) [data-name="option2"]:checked').forEach((option, index) => {

                    variant[`option${index + 1}`] = option.value;


                    product.properties[option.closest('fieldset').querySelector('legend').innerText.replaceAll(':', '')] = option.value;

                })

                // properties["length"] = 
                variant.price = product.price;
                variants.push(variant)


                let params = {
                    "body_html": "None",
                    "product_type": "custom",
                    "title": "Custom " + document.querySelector("[name=option]:checked").value,
                    "vendor": "Custom Product",
                    "status": "active",
                    "variants": variants


                }

              function transformProperties(properties) {
                return Object.keys(properties).map(key => {
                  return {
                    name: key,
                    value: properties[key]
                  };
                });
              }
              
              // Transform the item properties
              let transformedProperties = transformProperties(product.properties);

              let priceNew = product.price - chapasVariant.price / 100;

              let updatedPrice = 0;

              let line_items = [];

              document.querySelectorAll(".devProduct.active").forEach((product__)=>{


                priceNew = priceNew - product__.querySelector('[data-price]').dataset.price;
                line_items.push({
                    title: product__.dataset.title,
                    price : product__.querySelector('[data-price]').dataset.price,
                    quantity: 1,
                    custom: true,
                    properties: []
                })
                


              })

              
              line_items.push({
                title: document.querySelector("[name=option]:checked").value + " Customization",
                price : priceNew,
                quantity: 1,
                custom: true,
                properties: []
              })
              line_items.push({
                variant_id: chapasVariant.id,
                //price : priceNew,
                quantity: 1,
                custom: false,
                properties: transformedProperties
              })
              
             


              product.createDraft("", "", "",line_items )
              //  product.GenerateProduct(params);



            })
        }
    }


    createDraft = async (email, note, imageUrl, lineItems) => {
        try {
            //const response = await fetch("https://shopify-plugin-backend.fly.dev/draft/create-draft", {
            const response = await fetch("https://interchapas.7am.io/draft/create-draft", {
            
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email,
                note,
                image_url: imageUrl,
                line_items: lineItems
            })
            });

           
            const result = await response.json();

           
            if (result && result.draftOrder && result.draftOrder.invoice_url) {
            // Redirect to the invoice URL
            window.location.href = result.draftOrder.invoice_url;
            } else {
            console.error("Invoice URL not found in response:", result);

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Something went wrong!! Please try again',
                showConfirmButton: false,
                timer: 2000
            })


            //alert("Draft created, but no invoice URL was returned.");
            }
        } catch (error) {
            console.error("Error creating draft:", error);

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Something went wrong!! Please try again',
                showConfirmButton: false,
                timer: 2000
            })


            //alert("Something went wrong. Please try again.");
        }
    }

  GenerateOrder = async (params) =>{
    
  }
    GenerateProduct = async (params) => {
        const location = "https://interchapas.7am.io/";
        const settings = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        };
        try {
            const fetchResponse = await fetch(location, settings);
            const data = await fetchResponse.json();

            if (data.product) {
                let variant_id = data.product.variants[0].id;
                let quantity = 1;
                let properties = {

                    items: [{
                        quantity: 1,
                        id: variant_id,
                        properties: product.properties
                    }]



                };

                console.log(properties)

                product.setupATC(properties)

            }
            return data;
        } catch (e) {
            console.log(e)
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Something went wrong!! Please try again',
                showConfirmButton: false,
                timer: 2000
            })
            return e;
        }
    }
    setupATC = async (params) => {

      // debugger;
        if(document.querySelector(".copyTextInput")){
          if(document.querySelector(".checkout-url")){
            document.querySelector(".checkout-url").classList.remove("hidden");
            
            // document.querySelector("#copyTextInput")
          }
        }
        else{

          const locations = "/cart/add.js";
          const settings = {
              method: 'POST',
              headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(params)
          };
          try {
              const fetchResponse = await fetch(locations, settings);
              const data = await fetchResponse.json();
  

              console.log(data);
              location.href = "/cart"
  
              return data;
          } catch (e) {
  
              console.log(e)
              Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: 'Something went wrong in ATC PROCESS Please try again',
                  showConfirmButton: false,
                  timer: 2000
              })
              return e;
          }
          
        }
        


    }
    setupListener = () => {

        document.querySelector('.switch input').addEventListener('change', function() {

            if (!this.checked) {
                this.closest('.devCalculateAmount').querySelector(".box-selective").classList.add("hidden");
            } else {
              
                let value = parseFloat(document.querySelector('[name="length"]').value);
                let cutt = parseFloat(document.querySelector('[name="cut"]').value);
                if(value < 8.5 && cutt > value){
                  document.querySelector('[name="cut"]').value = value;
                }
                this.closest('.devCalculateAmount').querySelector(".box-selective").classList.remove("hidden");
            }
        })


        document.querySelectorAll(".custom-variant-sub-picker input + label").forEach(input => {
            input.addEventListener("click", function(e) {
                let $this = this;



                if ($this.closest('fieldset').querySelector("[value='" + $this.dataset.optionValue + "']")) {

                    $this.closest('fieldset').querySelector("[value='" + $this.dataset.optionValue + "']").checked = true;
                    $this.closest('fieldset').querySelector('variant-option-value').innerText = $this.closest('fieldset').querySelector("[value='" + $this.dataset.optionValue + "']").value;

                }

                if (this.previousElementSibling.dataset.name != "option3") {
                    product.updateVariants();
                }



            })
        })
        document.querySelectorAll(".custom-variant-sub-picker input").forEach(input => {
            input.addEventListener("changes", function(e) {

                e.preventDefault();


                this.checked = true;
                this.closest('fieldset').querySelector('variant-option-value').innerText = this.value;
                if (this.dataset.name != "option3") {
                    product.updateVariants();
                }


            })
        })
        document.querySelectorAll(".variant-picker__option-values [name='option']").forEach(
            li => {
                li.addEventListener("change", function() {

                    let value = this.value;


                    if (document.querySelector('.product-info__title')) {
                        document.querySelector('.product-info__title').innerText = this.value;
                    }
                    chapasProducts.forEach(product => {
                        if (product.title == this.value) {

                            document.querySelectorAll("fieldset[data-product]").forEach(pr => {
                                if (pr.dataset.product == product.id) {
                                    pr.classList.remove("hidden");
                                    pr.querySelector('input').checked = true

                                } else {
                                    pr.classList.add("hidden");
                                }
                            })

                        }
                    })

                    document.querySelector(".devCustomVariant variant-option-value").innerText = this.value;

                  product.updateVariants();

                  
                })



            })
        document.querySelectorAll(".variant-picker__option-values [name='option2']").forEach(
            li => {
                li.addEventListener("change", function() {

                    this.closest('fieldset').querySelector("variant-option-value").innerText = this.value;

                    // 
                    // document.querySelector(".devCustomVariant variant-option-value").innerText = this.value;


                })



            })

        document.querySelector('[name="cut"]').addEventListener("change", function() {


            if (parseFloat(this.value) > 8.5) {
                this.value = 8.5;
            } else {
                if (parseFloat(document.querySelector('[name="length"]').value) < parseFloat(this.value)) {
                    this.value = document.querySelector('[name="length"]').value;
                }
            }

        })
        document.querySelector('[name="length"]').addEventListener("change", function() {

            if (this.value < 8.5 && document.querySelector('.switch input').checked && document.querySelector('[name="cut"]').value > this.value) {
                document.querySelector('.switch input').checked = false;
                document.querySelector("[name='cut']").value = this.value;
                document.querySelector(".box-selective").classList.add("hidden");
            }
            if (this.value > 8.5) {
                document.querySelector("[name='cut']").value = "8.5";
                document.querySelector('.switch input').checked = true;
                document.querySelector('.box-selective').classList.remove('hidden');

            }
            if (this.value > 50) {
                this.value = "50";

            }
        })
        document.querySelector('[name="width"]').addEventListener("change", function() {

            if (this.value > 50) {
                this.value = "50";

            }
        })

        let initiateAdditionalProduct = () => {

          let additionalProducts = {};
            document.querySelectorAll(".devAddCartBtn").forEach(minus => {
                minus.addEventListener("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation()
                    e.stopImmediatePropagation()
                    if (this.closest('.devProduct').classList.contains('active')) {
                        this.closest('.devProduct').classList.remove('active')

                        
                        product.price -= parseFloat(this.dataset.price.replaceAll(',', '.'))


                    } else {
                        this.closest('.devProduct').classList.add('active')

                        let title = this.closest('.devProduct').dataset.title;
                        
                        let price = this.dataset.price.replaceAll(',', '.');
                        product.price += parseFloat(this.dataset.price.replaceAll(',', '.'))
                    }

                    
                    product.updatePrice();

                    let counter = 0;
                    document.querySelectorAll(".devAddCartBtn").forEach(pr => {
                      if (pr.closest('.devProduct').classList.contains('active')) {
                        counter++;
                        let title = pr.closest('.devProduct').querySelector('.tiltle').innerText;
                        
                        let price = pr.dataset.price.replaceAll(',', '.');
                        product.properties[`Accesorios ${counter}`] = title + " --- $" + price; 
                        
                      }
                      
                    })
                  

                })
            })

        }

        document.querySelector(".devConfigBtn").addEventListener("click", function(e) {
            e.preventDefault()

            let devMainGallery = document.querySelector(".devMainGallery");
            if (devMainGallery) {
                devMainGallery.classList.add("sticky");
            }
            if (document.querySelector(".devErrorMsg")) {
                document.querySelector(".devErrorMsg").remove();

            }
            if (document.querySelector(".dev-table")) {
                document.querySelector(".dev-table").classList.remove("dev-table")
            }
            if (document.querySelector(".graph-column")) {
                document.querySelectorAll(".graph-column").forEach(gc => {
                    gc.remove();
                })
            }
            if (document.querySelector(".graph-row")) {
                document.querySelectorAll(".graph-row .main-border").forEach(gc => {
                    gc.remove();
                })
            }
            if (document.querySelectorAll(".graph-row").length > 0) {
                document.querySelectorAll(".graph-row").forEach((gc, index) => {
                    if (index != 0) {
                        gc.remove();
                    } else {

                    }

                })
            }


            let width = parseFloat(document.querySelector("[name=width]").value);
            let height = parseFloat(document.querySelector("[name=length]").value);


            let product_width = document.querySelector('fieldset:not(.hidden) input[data-name="option3"]:checked').value.replaceAll(',', ".");
            product_width = width / product_width;

            if (!Number.isInteger(product_width)) {
              product_width = product_width.toFixed(2);
                
            }
           




            // document.querySelector(".graph-row").insertAdjacentH
            let cutOf = `

      <span class="border hidden main-border">
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
          <span class="border-item"></span>
        </span>
      
      `;


            let final_height = 0;

            product.isInit = false;
            product.properties = {};
            product.properties["Ancho"] = width;
            product.properties["Largo"] = height;

            let cutofFinal = 0;




            let tr = "";
            for (let j = 0; j < product_width; j++) {

                tr = tr + `<div class="graph-box">
            <div class="single-graph-item"></div>
            <div class="single-graph-item"></div>
            <div class="single-graph-item"></div>
            <div class="single-graph-item"></div>
            <div class="single-graph-item"></div>
            <div class="single-graph-item"></div>
          </div>`;



            }
            let th = `<div class="graph-column">${tr}</div> ${cutOf}`;



            document.querySelector(".graph-row").insertAdjacentHTML('afterbegin', th);




            document.querySelector('.top-border-custom span').setAttribute('data-before', width + "M");
            document.querySelector('.bottom-border span').setAttribute('data-before', document.querySelector("[name=length]").value + "M");

            if (document.querySelector('.switch input').checked && document.querySelector('[name="cut"]').value > 0) {


                let inputValue = document.querySelector('[name="cut"]').value;

                product.properties["Corte a"] = inputValue;



                if (inputValue >= parseFloat(document.querySelector("[name=length]").value)) {

                } else {



                    let diff = Math.round(inputValue)



                    let isInit = false;


                    let initalSets = diff;



                    let cutOFS = parseFloat(document.querySelector("[name=length]").value) / parseFloat(inputValue);



                    let cutOFSRound = Math.ceil(cutOFS)

                    for (let i = 1; i < cutOFSRound; i++) {

                        let elem = document.querySelector(".graph-row")
                        let clone = elem.cloneNode(true);



                        document.querySelector(".graph-row").insertAdjacentElement('afterend', clone);
                        if (i != cutOFSRound) {
                            if (document.querySelector(".graph-row .hidden")) {

                                document.querySelector(".graph-row .hidden").classList.remove("hidden")
                            }

                        }
                        // document.querySelector(".graph-row").insertAdjacentHTML('afterbegin', th);
                    }

                    document.querySelectorAll(".main-border").forEach(br => {
                        br.querySelector(".border-item").setAttribute('data-before', inputValue + "M")
                    })



                    let heightCalculation = parseFloat(inputValue) / parseFloat(document.querySelector("[name=length]").value);

                    heightCalculation = 200 * heightCalculation;
                    heightCalculation = heightCalculation.toFixed();



                    heightCalculation = 200 - heightCalculation;

                    if (height / inputValue != 2) {
                        if (document.querySelectorAll(".graph-row")[document.querySelectorAll(".graph-row").length - 1]) {
                            document.querySelectorAll(".graph-row")[document.querySelectorAll(".graph-row").length - 1].querySelector('.main-border').classList.add("hidden");
                            // document.querySelectorAll(".graph-row")[document.querySelectorAll(".graph-row").length -1].querySelectorAll('.graph-column .graph-box').forEach(tn=> tn.style.height = heightCalculation + "px");
                        }
                    }



                }


                //Checked VIDEO
            } else {


                if (document.querySelector(".middleHeight")) {
                    // document.querySelector(".middleHeight").classList.remove('middleHeight');
                }


            }


            

            if (document.querySelectorAll(".graph-row").length > 1) {
                let offsetWidth = document.querySelector('.graph-column').offsetWidth;

                let currentBoxWidth = document.querySelector('.graph-box').offsetWidth;

                
                
                
                let finalWidth = product_width;
                if (!Number.isInteger(product_width)) {
                    finalWidth = product_width + .5;
                }
                let totalBoxWidth = document.querySelector('.graph-box').offsetWidth * finalWidth;
                let finalextraPadding = (offsetWidth - totalBoxWidth) / 2;
                let currentBox =  document.querySelector('.graph-row');

                let style = currentBox.currentStyle || window.getComputedStyle(currentBox);


              
                if (product_width >= 4) {
                    if (window.innerWidth > 767) {

                        document.querySelector("span.border.top-border-custom-left").style.left = (80) + "px";
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = (80) + "px";
                    } else {
                      
                        document.querySelector("span.border.top-border-custom-left").style.left = style.marginLeft;
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = style.marginRight;
                    }


                } else {

                    if (window.innerWidth > 767) {
                        if (width > 2) {
                            finalextraPadding = finalextraPadding - 1;
                        }
                        document.querySelector("span.border.top-border-custom-left").style.left = (80 + (finalextraPadding - width)) + "px";
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = (80 + (finalextraPadding - width)) + "px";
                        document.querySelectorAll('.graph-container span.border.top-border span.border-item, .graph-container span.border.bottom-border span.border-item').forEach(item => {
                            item.style.width = (offsetWidth - totalBoxWidth) / 4.2 + "px";
                        })
                    } else {
                        if (product_width > 2) {
                            finalextraPadding = finalextraPadding - 1;
                        }
                     


                        let padding = 80 +  (offsetWidth - (totalBoxWidth )) / 2
                      
                      
                       
                        document.querySelector("span.border.top-border-custom-left").style.left = padding + "px";
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = padding + "px";

                    
                      
                        
                        // document.querySelector("span.border.top-border-custom-left").style.left = style.marginLeft;
                        // document.querySelector(".graph-container span.border.top-border-custom").style.right = style.marginRight;
                        document.querySelectorAll('.graph-container span.border.top-border span.border-item, .graph-container span.border.bottom-border span.border-item').forEach(item => {
                         
                            
                                item.style.width = padding / 4 + "px";
                            
                        })
                    }



                }


                let totalBoxHeight = totalBoxWidth;

                if (height > product_width) {

                    totalBoxHeight = totalBoxWidth * (height / product_width);

                    // totalBoxWidth+= 50;
                } else
                if (product_width > height) {



                    totalBoxHeight = totalBoxWidth * (height / product_width);

                    // totalBoxWidth-= 50;
                } else
                if (product_width == height) {

                    totalBoxHeight = totalBoxWidth;
                }
                if (totalBoxHeight > 1500) {
                    totalBoxHeight = 1500;
                }
                let cutOF = parseFloat(document.querySelector("[name='cut']").value);
                let numberOfBox = Math.ceil(height / cutOF);
                let percentageCutOF = cutOF / height;
                let firstPhaseHeight = totalBoxHeight * percentageCutOF;
                let lastPhaseHeight = totalBoxHeight - (firstPhaseHeight * (numberOfBox - 1));

                document.querySelectorAll(".graph-row").forEach((row, index) => {
                    row.querySelectorAll('.graph-box').forEach((box) => {
                        if (index != document.querySelectorAll('.graph-row').length - 1) {
                            box.style.height = firstPhaseHeight + "px";
                        } else {
                            box.style.height = lastPhaseHeight + "px";
                        }
                    })
                });

            } else {

                // if(document.querySelectorAll('.graph-column .graph-box').length <= 3){
                let offsetWidth = document.querySelector('.graph-column').offsetWidth;

                let currentBoxWidth = document.querySelector('.graph-box').offsetWidth;

               
                
                let finalWidth = product_width;
                if (!Number.isInteger(product_width)) {
                    finalWidth = product_width + .5;
                }
                
                let totalBoxWidth = document.querySelector('.graph-box').offsetWidth * finalWidth;
                let finalextraPadding = (offsetWidth - totalBoxWidth) / 2;

                let totalBoxHeight = totalBoxWidth;

                if (height > product_width) {

                    totalBoxHeight = totalBoxWidth * (height / product_width);

                    // totalBoxWidth+= 50;
                } else
                if (product_width > height) {

                    totalBoxHeight = totalBoxWidth * (height / product_width);

                    // totalBoxWidth-= 50;
                } else
                if (product_width == height) {

                    totalBoxHeight = totalBoxWidth
                }

                let firstPhaseHeight = totalBoxHeight;


                let currentBox =  document.querySelector('.graph-row');

                let style = currentBox.currentStyle || window.getComputedStyle(currentBox);


                if (width >= 4) {
                    // document.querySelector("span.border.top-border-custom-left").style.left = (80  )+ "px";
                    // document.querySelector(".graph-container span.border.top-border-custom").style.right = (80  )+ "px";
                    if (window.innerWidth > 767) {
                        document.querySelector("span.border.top-border-custom-left").style.left = (80) + "px";
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = (80) + "px";
                    } else {

                      document.querySelector("span.border.top-border-custom-left").style.left = style.marginLeft;
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = style.marginRight;
                        // document.querySelector("span.border.top-border-custom-left").style.left = (40) + "px";
                        // document.querySelector(".graph-container span.border.top-border-custom").style.right = (40) + "px";
                    }

                } else {
                    if (window.innerWidth > 767) {
                        if (width > 2) {
                            finalextraPadding = finalextraPadding - 1;
                        }
                        document.querySelector("span.border.top-border-custom-left").style.left = (80 + (finalextraPadding - width)) + "px";
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = (80 + (finalextraPadding - width)) + "px";
                    } else {


                      let padding = 80 +  (offsetWidth - (totalBoxWidth )) / 2;
                      
                      
                        document.querySelector("span.border.top-border-custom-left").style.left = padding + "px";
                        document.querySelector(".graph-container span.border.top-border-custom").style.right = padding + "px";

                    }
                }



                document.querySelectorAll('.graph-container span.border.top-border span.border-item, .graph-container span.border.bottom-border span.border-item').forEach(item => {
                    if ((offsetWidth - (document.querySelector('.graph-box').offsetWidth * width)) / 4.5 > 20) {
                        let padding = 80 +  (offsetWidth - (totalBoxWidth )) / 2;
                        if (window.innerWidth < 767) {
                            
                                item.style.width = padding / 4 + "px";
                            
                        } else {
                            item.style.width = (offsetWidth - (document.querySelector('.graph-box').offsetWidth * width)) / 4.2 + "px";
                        }

                    }

                })

                document.querySelectorAll(".graph-row").forEach((row, index) => {
                    row.querySelectorAll('.graph-box').forEach((box) => {

                        box.style.height = firstPhaseHeight + "px";

                    })
                });




            }

            

            if (!Number.isInteger(product_width)) {
                document.querySelectorAll(".graph-row").forEach((row, i) => {

                    let offsetWidth = document.querySelector('.graph-column').offsetWidth;
                    offsetWidth = offsetWidth - 78;
                    let gridWidth = offsetWidth / product_width;




                    row.querySelectorAll(".graph-column .graph-box").forEach((box, index) => {

                        if (index == row.querySelectorAll(".graph-column .graph-box").length - 1) {

                            let widths = document.querySelector('.graph-column').offsetWidth;
                            let allBox = document.querySelector('.graph-box').offsetWidth * product_width;


                            let offset = box.offsetWidth / 2;
                            let currentRight = document.querySelector('.graph-container span.border.top-border-custom').style.right.replaceAll("px", "");
                            if (i == 0) {
                                document.querySelector('.graph-container span.border.top-border-custom').style.right = parseFloat(currentRight) + offset + "px";
                            }

                            // box.style.width = gridWidth + "px"
                            box.classList.add("half");
                        }


                    })

                })
            } else {
                // document.querySelector('.graph-container span.border.top-border-custom').style.right = 80 + "px";
            }

            let value = document.querySelector('.variant-picker__option-values [name="option"]:checked').value;
            product_width = 0;
            let  price_per_meter = 0;

            if (document.querySelector('.variant-picker__option:not(.hidden) [data-name="option2"]:checked+label')) {
                let color = document.querySelector('.variant-picker__option:not(.hidden) [data-name="option2"]:checked+label').dataset.optionValue;
                document.querySelector('.basicTable').setAttribute('data-color', color);
            }


            chapasProducts.forEach(pr => {
                if (pr.title == value) {
                    console.log(pr.title)
                    let variants = JSON.parse(pr.variants);
                    let selectedHASH = {};
                    document.querySelectorAll(`[data-product="${pr.id}"] input:checked`).forEach((input) => {

                        if (input.dataset.name) {
                            selectedHASH[`${input.dataset.name}`] = input.value;
                        } else {
                            selectedHASH[`${input.name}`] = input.value;
                        }

                    })

                  
                    product_width = pr.width
                    variants.forEach(variant => {
                        

                        // console.log(variant.option1 + "---" + variant.option2 + "----" + variant.option3 + "--HI__" + selectedHASH.option1 + "---" + selectedHASH.option2 + "---" + selectedHASH.option3)
                        // console.log(variant.option1 == selectedHASH.option1 && variant.option2 == selectedHASH.option2 && selectedHASH.option3 == variant.option3)

                        if (variant.option1 == selectedHASH.option1 && variant.option2 == selectedHASH.option2 && selectedHASH.option3 == variant.option3) {

                            if (variant.featured_image) {
                                document.querySelector('.devMainProBox img').src = variant.featured_image.src;

                            } else {
                                document.querySelector('.devMainProBox img').src = "https://cdn.shopify.com/s/files/1/0709/1332/7406/files/gorilla.jpg?v=1679435911";
                            }
                          
                            price_per_meter = variant.price / 100;
                        }

                    })
                }
            })


          if(document.querySelector('fieldset:not(.hidden) input[data-name="option3"]:checked')){
            product_width = document.querySelector('fieldset:not(.hidden) input[data-name="option3"]:checked').value.replaceAll(',', ".")
          }
            // (Width / Product Width) * Length * Price Per Meter
            let price = Math.ceil((width / product_width)) * parseFloat(document.querySelector('[name="length"]').value) * price_per_meter;


            document.querySelectorAll(".devProductList, .devTotalAmount").forEach(li => {
                li.classList.remove("hidden");
            })
            let roundUp = 0;
            if (document.querySelector('.switch input')) {
                // roundUp
            }
            // CALCULATE PRICE
            if (document.querySelector('.switch input').checked && document.querySelector('[name="cut"]').value > 0) {
                // price = 
                product.properties["Montaje"] = document.querySelector('[name="overlap"]').value;

              
                let farmula = ((height / parseFloat(document.querySelector('[name="cut"]').value)).toFixed(1))  * (parseFloat(document.querySelector('[name="overlap"]').value) /100) * Math.ceil((document.querySelector('[name="width"]').value / product_width));
                let overlap_price = farmula * price_per_meter;
                if (farmula) {
                    price = price + overlap_price;

                }

            }
            product.price = price;


            let additionalPricePacks = 0;

            additionalPricePacks = (parseFloat(document.querySelector('[name="length"]').value) * parseFloat(document.querySelector('[name="width"]').value)) * 5;


            let packs = 0;
            if (additionalPricePacks <= 50) {
                packs = 1;
            } else {
                packs = Math.ceil(additionalPricePacks / 50); //(additionalPricePacks / 50).toFixed(0);
            }



            document.querySelectorAll('.devProduct[data-id]').forEach((pr, index) => {
                pr.querySelector('[data-price]').dataset.price = (packs * (pr.querySelector('[data-prices]').dataset.prices / 100))
                pr.querySelector('sale-price').innerText = "$" + (packs * (pr.querySelector('[data-prices]').dataset.prices / 100))
                let title = pr.querySelector('.tiltle');
                pr.querySelector('.tiltle').innerText = (packs * 50) + " X " + title.dataset.title;
            })

            document.querySelector(".final-price").innerText = "$" + price.toFixed("2")
            document.querySelector(".devMainProBox").classList.remove("hidden");
            // buy-buttons

            let title = document.querySelectorAll('fieldset:not(.hidden) input:checked')[0].value + " / " + document.querySelectorAll('fieldset:not(.hidden) input:checked')[1].value + " / " + document.querySelectorAll('fieldset:not(.hidden) input:checked')[2].value + " / " + document.querySelectorAll('fieldset:not(.hidden) input:checked')[3].value;
            // title = title + " / " + document.querySelectorAll('.variant-picker__option-values input:checked')
            // let title = value + " / " +     document.querySelector('.variant-picker__option-values [name=option1]:checked').value + " / " +     document.querySelector('.variant-picker__option-values [name=option2]:checked').value;
            document.querySelector(".devMainProBox .tiltle").innerText = title;
            document.querySelector(".devMainProBox .price").innerText = "$" + price.toFixed("2");

            document.querySelector(".devTotalAmount").classList.remove('hidden');
            document.querySelector(".product-info__buy-buttons").classList.remove('hidden');


            initiateAdditionalProduct();




        })


        let devMainGallery = document.querySelector(".devMainGallery");
        // document.addEventListener("scroll", function(){
        //   if(devMainGallery && product.isInit ){
        //     let scroll = document.documentElement.scrollTop || document.body.scrollTop;

        //     if(scroll > 1){
        //       devMainGallery.classList.add("sticky");
        //     }
        //     else{
        //       devMainGallery.classList.remove("sticky");
        //     }
        //   }
        //   else{
        //     devMainGallery.classList.remove("sticky");
        //   }
        // })

        document.querySelectorAll("[name='width'], [name='length']").forEach(input => {
            input.addEventListener("change", function(e) {
                if (typeof this.value === 'string' || this.value instanceof String) {

                }

            })
        })



    }
}

let product = new ProductCustomization();
if(document.querySelector('[data-option="calibre"]:not(.hidden) input:checked~label')){
  document.querySelector('[data-option="calibre"]:not(.hidden) input:checked~label').click()
}
